// Vendor plugins - Minimal Vite bundle
// All jQuery plugins, moment, socket.io, toastr, etc. are loaded via script tags in app_assets.blade.php
// This file only imports Modernizr and the vetology application modules

import "./../../assets/js/vendor/Modernizr/Modernizr/modernizr.js";

// Bootstrap tooltip/popover whitelist config - allow dl/dt/dd elements in popover content
// (Bootstrap is loaded via script tag in app_assets.blade.php before this runs)

if (
    typeof jQuery !== "undefined" &&
    jQuery.fn.tooltip?.Constructor?.DEFAULTS?.whiteList
) {
    jQuery.fn.tooltip.Constructor.DEFAULTS.whiteList["dl"] = [];
    jQuery.fn.tooltip.Constructor.DEFAULTS.whiteList["dt"] = [];
    jQuery.fn.tooltip.Constructor.DEFAULTS.whiteList["dd"] = [];
}

// Import vetology modules
// These run after all vendor libs are loaded via script tags
import "./vetology_base.js";
import "./vetology.js";
